import rootLogger from "./log";

const log = rootLogger.getLogger('utils');

export function debounce(func, timeout = 100){
    let timer;
    return function(event){
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(func, timeout, event);
    };
}

export function toggleChildVisibility(element)
{
    Array.from(element.children).forEach(child => {
        if (child.classList) {
            child.classList.toggle('visually-hidden');
        }
    });
}

export function getMeta(metaName) {
    const metaElement = document.head.querySelector('meta[name=' + metaName + ']');
    if (metaElement) {
        return metaElement.content;
    }
    log.warn(`meta tag with name "${metaName}" is not available.`);
    return '';
}

export function pingMetaUrl(metaTagName)
{
    const url = getMeta(metaTagName);
    if (!url) return;

    log.debug(`Pinging URL from meta tag "${metaTagName}": ${url}`);
    fetch(url, {keepalive: true})
        .catch(reason => log.warn(`Failed to ping ${metaTagName}:`, reason));
}

export function refreshRestCaches() {
    document.querySelectorAll('meta[data-cached-by-service-worker="rest"]').forEach(meta => {
        pingMetaUrl(meta.name);
    });
}

export function moveInArray(array, fromIndex, toIndex)
{
    let movingElement = array.splice(fromIndex, 1)[0];
    array.splice(toIndex, 0, movingElement);
}

export function calculateNewIndex (oldIndex, bigArray, inElementIndex, inElementType, newEventIndex)
{
    let indices = bigArray
        .filter(elementToFilter =>
            elementToFilter[inElementType + 'Index'] === inElementIndex,
        )
        .map(elementMap => bigArray.indexOf(elementMap));
    let newIndex = indices[newEventIndex] ?? indices.length;
    if (newIndex > oldIndex && bigArray[oldIndex][inElementType + 'Index'] !== inElementIndex) {
        newIndex -= 1;
    }
    return newIndex;
}

export function handleChildCheckboxes(event, className)
{
    const subCheckboxes = Array.from(
        event.target.closest(`.${className}`).querySelectorAll('input[type="checkbox"][name]:not(:disabled)')
    ).filter(checkbox => checkbox !== event.target);
    if (subCheckboxes.filter(checkbox => checkbox.checked !== event.target.checked).length
        === subCheckboxes.length) {
        subCheckboxes.forEach(checkbox => {
            if (checkbox.checked !== event.target.checked) {
                checkbox.checked = event.target.checked;
            }
        });
    }
}

export function stringCompare(a, b) {
    return a.localeCompare(b);
}

export function stringCompareWithWrap(wrap) {
    return (a, b) => stringCompare(wrap(a), wrap(b));
}

export function getCmInPx(sizeInCm)
{
    return sizeInCm / 2.54 * (96 / window.devicePixelRatio);
}

/**
 * @param {HTMLElement[]} siblings
 * @param {{top: string, nextTop: string, nextStickyLevel: Number}} properties defaultProperties for first child
 */
export function calculateStickySibling(siblings, properties = {top: '50px', currentTop: 'var(--height-for-sticky)', currentStickyLevel: 500})
{
    let previousStickyElement;
    let additionalTop = properties.top;
    for (const sibling of siblings) {
        if (previousStickyElement !== undefined) {
            additionalTop += ` + ${getComputedStyle(previousStickyElement).getPropertyValue('--height-for-sticky')}`;
            properties = {
                top: `calc(-${sibling.getBoundingClientRect().height}px + ${additionalTop} + var(--height-for-sticky))`,
                currentTop: `calc(${additionalTop})`,
                currentStickyLevel: parseInt(previousStickyElement.style.getPropertyValue('--current-sticky-level')) + 1,
            };
        }
        const heightForSibling = sibling.dataset.overwriteHeightForSticky
            ?? `${sibling.querySelector('.card-header, .accordion-header').getBoundingClientRect().height}px`;
        sibling.style.setProperty('top', properties.top);
        sibling.style.setProperty('--current-top', properties.currentTop);
        sibling.style.setProperty('--current-sticky-level', properties.currentStickyLevel.toString());
        sibling.style.setProperty('--height-for-sticky', heightForSibling);
        previousStickyElement = sibling;
    }
}

export const renderOffice = function(template, previewElement, selectElement) {
    const currentPreview = previewElement.parentElement.querySelector('.preview');
    let object = JSON.parse(currentPreview?.dataset.current ?? 'null');
    if (object !== null) {
        if (object.address === undefined) {
            object.address = object;
        }
        currentPreview.innerHTML = Mustache.render(template, object);
    }
    if (selectElement instanceof HTMLElement) {
        $(selectElement).on('change', () => {
            /* TODO: on change or select or whatever event is really triggered it should also renew the correct preview,
                but currently I don't find the event with sufficient information.
                Therefor, on click we get the correct preview but empty it so there is no faulty information.
             */
            currentPreview.innerHTML = '';
        });
    }
    return function(ul, item) {
        let object = $(item.option).data('object');
        if (object === undefined) {
            return $('<li>').append(item.label).appendTo(ul);
        }
        if (object.address === undefined) {
            object.address = object;
        }
        const title = Mustache.render(template, object);
        const label = (object.address.customer ? 'K' : '') + (object.address.location ? 'O' : '') + (object.address.insurant ? 'V' : '') + ' ' + object.address.company;

        return $("<li>").hover(
            function () {
                setTimeout(() => {
                    // NOTE: setTimeout to be sure to draw it after the hover leave (below)
                    previewElement.closest('.parentDialog').style['overflow-x'] = 'visible';
                    previewElement.innerHTML = title;
                    previewElement.showPopover({source: selectElement});
                }, 0);
            },
            () => {
                previewElement.closest('.parentDialog').style.removeProperty('overflow-x');
                previewElement.innerHTML = '';
                previewElement.hidePopover();
            })
            .on('click', () => {
                setTimeout(() => {
                    // TODO: poor man solution, see above, and the setTimeout to render this after emptying preview.
                    currentPreview.innerHTML = title;
                }, 0);
            })
            .append($("<a>").text(label))
            .appendTo(ul);
    };
};
